export default __webpack_public_path__ + "static/sharp-d8900edd246b5e2291fba0739f2a319c.png";